import apiClient from "../core/HttpClient";

export default class ExerciseService{
    url="/Exercises";
    async getExercises(){
        return apiClient.get(this.url).then((response) => {
            return response.data;
        });        
    }
    async getExercise(id: string){
        return apiClient.get(`${this.url}/${id}`).then((response) => {
            return response.data;
        });        
    }

    async addExercise(data: any){
        return apiClient.post(this.url, data);
    }

    async updateExercise(id: string, data: any){
        return apiClient.put(`${this.url}/${id}`, data);
    }

    async deleteExercise(id: string){
        return apiClient.delete(`${this.url}/${id}`).then((response) => {
            return response.data;
        });
    }
    
}